import { render, staticRenderFns } from "./CompanyEditModuleMetaDataMaxDocuments.vue?vue&type=template&id=20899aa4&"
import script from "./CompanyEditModuleMetaDataMaxDocuments.vue?vue&type=script&lang=ts&"
export * from "./CompanyEditModuleMetaDataMaxDocuments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20899aa4')) {
      api.createRecord('20899aa4', component.options)
    } else {
      api.reload('20899aa4', component.options)
    }
    module.hot.accept("./CompanyEditModuleMetaDataMaxDocuments.vue?vue&type=template&id=20899aa4&", function () {
      api.rerender('20899aa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/CompanyEditModuleMetaDataMaxDocuments.vue"
export default component.exports